import initializeSignatureContent from '../actions/initializeSignatureContent';
import SignatureOptionState from '../store/schema/SignatureOptionState';
import store from '../store/store';
import RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { ReactEditor } from 'owa-editor';
import { computed } from 'mobx';
import { Ribbon } from 'owa-editor-ribbonplugin';
import { EditorPlugin } from 'roosterjs-editor-core';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./SignatureOption.scss');

export interface SignatureEditorProps {
    optionStore?: SignatureOptionState;
    userOptions?: UserOptionsType;
    isRtl?: boolean;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
    isRtl: () => getUserConfiguration().SessionSettings.IsUserCultureRightToLeft,
})
export default class SignatureEditor extends React.Component<SignatureEditorProps, {}> {
    private ribbonPlugin: RibbonPlugin;

    constructor(props: SignatureEditorProps) {
        super(props);
        this.ribbonPlugin = new RibbonPlugin(this.props.optionStore.ribbon);
    }

    componentDidMount() {
        initializeSignatureContent();
    }

    render() {
        let { optionStore, isRtl } = this.props;

        return (
            <div className={styles.editorContainer}>
                {this.isMessageOptionsFetchComplete ? (
                    [
                        <Ribbon
                            key="ribbon"
                            ribbonPlugin={this.ribbonPlugin}
                            viewState={optionStore.ribbon}
                            className={styles.ribbon}
                            isRtl={isRtl}
                        />,
                        <ReactEditor
                            key="editor"
                            isRtl={isRtl}
                            viewState={optionStore.editorViewState}
                            plugins={this.plugins}
                            classNames={styles.editor}
                            updateOnKeyPress={true}
                            ariaLabel={strings.options_signature_aria_label}
                        />,
                    ]
                ) : (
                    <div className={styles.loading}>
                        <Spinner size={SpinnerSize.medium} />
                    </div>
                )}
            </div>
        );
    }

    private get plugins(): EditorPlugin[] {
        // VSO 14829 - Use a common collection of plugins
        return [this.ribbonPlugin];
    }

    @computed
    private get isMessageOptionsFetchComplete() {
        let { optionStore } = this.props;

        return optionStore.editorViewState.content !== null;
    }
}
